import React from 'react';
import { Card, Typography } from 'antd';
import { useTheme } from '../contexts/ThemeContext';

const { Title } = Typography;

export const GrafanaLogs: React.FC = () => {
  const { isDark } = useTheme();

  return (
    <div>
      <div style={{ marginBottom: 16, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <Title level={2}>Логи Grafana</Title>
      </div>
      <Card>
        <div
          style={{
            width: '100%',
            overflow: 'hidden',
            borderRadius: 8,
            border: `1px solid ${isDark ? '#424242' : '#f0f0f0'}`,
          }}
        >
          <iframe
            src={import.meta.env.VITE_LOGS_URL || 'https://logs.sion.one/app/r/s/Y3Tkc'}
            height="600"
            width="800"
            style={{
              border: 'none',
              display: 'block',
              width: '100%',
              height: 'calc(100vh - 200px)',
              minHeight: 600,
            }}
            title="Grafana Logs"
          />
        </div>
      </Card>
    </div>
  );
};
